import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-mall-topology",
  "use": "icon-soc-l1-mall-topology-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-mall-topology\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M512 192a64 64 0 1 1 0 128 64 64 0 0 1 0-128zM256 448a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm512 0a64 64 0 1 1 0 128 64 64 0 0 1 0-128zM384 736a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm256 0a64 64 0 1 1 0 128 64 64 0 0 1 0-128z\" />\r\n  <path d=\"M504 320h16v128h-16V320zM304 496h128v16H304v-16zm288 0h128v16H592v-16zM424 560h16v160h-16V560zm160 0h16v160h-16V560z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-mall-topology.svg
// module id = Brpc
// module chunks = 492